import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getGalleries(keyword = '') {
        return Api().get(`/Gallery${keyword ? '?Keyword=' + keyword : ''}`);
    },

    /*  2. Get one column */
    getGallery(id) {
        return Api().get(`/Gallery/${id}`);
    },

     /*  3. Create one column */
    saveGallery(body) {
        return Api().post(`/Gallery`, body);
    },

     /*  4. Delete one or more column */
    deleteGalleries(galleries) {
        return Api().post(`/Gallery/DeleteGallery`, galleries);
    },

    /*  5. post one or more columns */
    postGalleries( galleries) {
        return Api().post(`/Gallery/PostGallery`, galleries);
    },
}